interface PlayButtonProps {
  onToggleTTS: () => void;
  isPlaying: boolean;
}

const PlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-play"
  >
    <polygon points="6 3 20 12 6 21 6 3" />
  </svg>
);

const PauseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-pause"
  >
    <rect x="14" y="4" width="4" height="16" rx="1" />
    <rect x="6" y="4" width="4" height="16" rx="1" />
  </svg>
);

export const PlayButton = ({ onToggleTTS, isPlaying }: PlayButtonProps) => {
  return (
    <button
      className={`icon play-button ${isPlaying ? 'playing' : ''}`}
      onClick={onToggleTTS}
      aria-label={isPlaying ? 'Pause text-to-speech' : 'Play text-to-speech'}
      title={isPlaying ? 'Pause text-to-speech' : 'Play text-to-speech'}
    >
      {isPlaying ? <PauseIcon /> : <PlayIcon />}
    </button>
  );
};
